import CableReady from "cable_ready"
import { debounce } from "underscore"

const inputEvent = async function(event) {
  const element = event.currentTarget
  element.debouncedFetchResults()
}

const debouncedInputEvent = debounce(inputEvent, 300)

const changeEvent = async function(event) {
  const element = event.currentTarget.closest(`attendance-search-combobox`)
  element.redirectToAttendanceConfirmation()
}

const optionsFetchedEvent = async function(event) {
  const element = event.currentTarget
  element.applyFetchedOptions(event.detail.updateFloor)
}

class AttendanceSearchCombobox extends HTMLElement {
  async connectedCallback() {
    await customElements.whenDefined("wa-combobox")

    if (!this.isConnected) { return }

    this.addEventListener(`input`, inputEvent)
    this.addEventListener(`change`, changeEvent)
    this.addEventListener(`app:combobox-options-fetched`, optionsFetchedEvent)
  }

  get debouncedFetchResults() {
    if(!this._debouncedFetchResults) {
      this._debouncedFetchResults = debounce(this.fetchResults.bind(this), 300)
    }

    return this._debouncedFetchResults
  }

  async fetchResults() {
    if(!this.queryValue){ return }

    const url = new URL(this.getAttribute("src"), window.location.origin)
    url.searchParams.set("q", this.queryValue)

    const response = await window.mrujs.fetch(url, {
      dispatchEvents: true,
      headers: {"Accept": window.mrujs.mimeTypes.cablecar}
    })
  }

  async applyFetchedOptions(updateFloor) {
    // Throw away older requests if we got a newer one
    if(this._updateFloor && this._updateFloor > updateFloor) {
      return
    } else {
      this._updateFloor = updateFloor
    }

    const combobox = this.combobox

    await new Promise((resolve) => {
      requestAnimationFrame(async () => {
        if (combobox.open) {
          await combobox.updateFilteredOptions()
        } else {
          await combobox.show()
        }

        resolve()
      })
    })
  }

  redirectToAttendanceConfirmation() {
    // If the combobox is cleared of text that was entered, we don't want to proceed further
    if (!this.combobox.value) { return }

    let redirectURL = new URL(this.combobox.value, window.location.origin)
    window.location.href = redirectURL
  }

  get queryValue() {
    return (this.combobox.inputValue || "").trim()
  }

  get combobox() {
    return this.querySelector("wa-combobox")
  }
}

if (!window.customElements.get("attendance-search-combobox")) {
  window.customElements.define("attendance-search-combobox", AttendanceSearchCombobox)
}
